import { apiRequest } from './axiosConfig';
import type { BannerBatchStatusResponse, BannerResult } from '../../types/onboarding';

export interface SignupGenerateBannersResponse {
  success: boolean;
  session_id: string;
  banners: BannerResult[];
  total_count: number;
  message?: string;
}

/**
 * Signup後オンボーディング用のバナー生成 API（認証必須）。
 * 既存の onboardingService.ts は未認証 axios のため使わない。
 */
class SignupOnboardingService {
  /**
   * 商品IDを指定して10枚のバナー生成を開始する。
   * 組織ごとに1回限り。既に生成済みの場合は 409 を返す。
   */
  async generateBanners(productId: number): Promise<SignupGenerateBannersResponse> {
    const config = { timeout: 60000 };
    return apiRequest.post<SignupGenerateBannersResponse>(
      'onboarding/signup/generate-banners',
      { product_id: productId },
      config,
    );
  }

  /**
   * バナー生成セッションのステータスを取得（ポーリング用）。
   * 既存 getBatchStatus と同形のレスポンス。
   */
  async getBannerStatus(sessionId: string): Promise<BannerBatchStatusResponse> {
    const config = { timeout: 30000 };
    return apiRequest.get<BannerBatchStatusResponse>(
      `onboarding/signup/banner-status/${sessionId}`,
      config,
    );
  }
}

export default new SignupOnboardingService();
